import * as React from 'react';

import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { ServiceLocator } from '../../ServiceLocator';

export const DefaultServerTitleWrapper: React.FunctionComponent<{}> = props => {
  React.useEffect(() => {
    ServiceLocator.get<BrowserTitleService>('BrowserTitleService').setTitleToServerName();
  }, []);

  return <>{props.children}</>;
};
